import { useT, renderRich } from "@/context/LanguageContext";
import { TESTIDS } from "@/constants/testIds";

const LanguageSwitcher = ({ variant = "header" }) => {
  const { lang, setLang, langs } = useT();
  const isFooter = variant === "footer";
  return (
    <div data-testid="language-switcher" className={`flex items-center gap-1 font-typewriter text-[10px] tracking-[0.22em] uppercase ${isFooter ? "text-[#6B6862]" : ""}`}>
      {langs.map((l, i) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}`}
          onClick={() => setLang(l.code)}
          className={`transition-colors ${lang === l.code ? "text-[#C97A63]" : "hover:text-[#2C2C2C]"}`}
          aria-label={l.label}
        >
          {l.code.toUpperCase()}{i < langs.length - 1 ? <span className="mx-1 opacity-40">·</span> : null}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
// Note: renderRich and TESTIDS imported above are re-exported helpers but not used here directly.
export { renderRich, TESTIDS };
